import { defineMessages } from 'react-intl'

export default defineMessages({
  help: {
    id: 'NewHereModal.Help',
    defaultMessage: 'Help'
  },
  gettingStartedGuide: {
    id: 'NewHereModal.GettingStartedGuide',
    defaultMessage: 'Getting started guide'
  },
  gettingStartedSubTitle: {
    id: 'NewHereModal.GettingStartedSubTitle',
    defaultMessage: 'Learn to be a champion of Workgrid - one feature at a time!'
  },
  articles: {
    id: 'NewHereModal.Articles',
    defaultMessage: 'Articles'
  },
  articlesSubTitle: {
    id: 'NewHereModal.ArticlesSubTitle',
    defaultMessage: 'Review all available documentation related to a category.'
  },
  integrations: {
    id: 'NewHereModal.Integrations',
    defaultMessage: 'Integrations'
  },
  integrationsSubTitle: {
    id: 'NewHereModal.IntegrationsSubTitle',
    defaultMessage: 'View available integrations and how to set them up.'
  },
  releaseNotes: {
    id: 'NewHereModal.ReleaseNotes',
    defaultMessage: 'Release notes'
  },
  releaseNotesSubTitle: {
    id: 'NewHereModal.ReleaseNotesSubTitle',
    defaultMessage: 'See what’s changed by visiting all of our monthly releases.'
  },
  tutorials: {
    id: 'NewHereModal.Tutorials',
    defaultMessage: 'Tutorials'
  },
  tutorialsSubTitle: {
    id: 'NewHereModal.TutorialsSubTitle',
    defaultMessage: 'Learn with interactive tutorials which will guide you step-by-step.'
  },
  resourceHub: {
    id: 'NewHereModal.ResourceHub',
    defaultMessage: 'Resource hub'
  },
  resourceHubSubTitle: {
    id: 'NewHereModal.ResourceHubSubTitle',
    defaultMessage: 'Digital workplace guides, videos, podcasts, and more.'
  },
  developers: {
    id: 'NewHereModal.Developers',
    defaultMessage: 'Developers'
  },
  developersSubTitle: {
    id: 'NewHereModal.DevelopersSubTitle',
    defaultMessage: 'Developer specific articles to setup your Workgrid experience.'
  },
  askSupport: {
    id: 'NewHereModal.AskSupport',
    defaultMessage: 'Ask support'
  },
  askSupportSubTitle: {
    id: 'NewHereModal.AskSupportSubTitle',
    defaultMessage: 'Get specific help on an issue or submit a bug report.'
  }
})
